import { render, staticRenderFns } from "./CanvasSvg.vue?vue&type=template&id=4ab162e8&"
import script from "./CanvasSvg.vue?vue&type=script&lang=js&"
export * from "./CanvasSvg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports